
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import Input from '@/components/Core/Input.vue';

  import { IErrorModel } from '@/models/errors.model';
  import { IIdentifyUserModel, IIdentifyUserResultModel, ILoginPartnerModel } from '@/models/login.model';

  import accountService from '@/services/account.service';
  import recaptchaService from '@/services/recaptcha.service';

  @Component({
    components: {
      Input
    },
    computed: {
      ...mapGetters([
        'isLoading'
      ])
    }
  })
  export default class LoginHome extends Vue {
    data() {
      return {
        isIdentifying: false,
        isFocused: false,
        isLabeled: false,
        errors: new Array<IErrorModel>(),
        hasConfirmedError: false,
        form: {
          ClientId: this.$route.query.client_id,
          RedirectUrl: this.$route.query.redirectUrl
        } as IIdentifyUserModel
      }
    };

    public identifyUser() {
      if (this.$data.isIdentifying) {
        return;
      }

      this.$store.dispatch("updateIsLoading", true);
      this.$data.isIdentifying = true;
      this.$data.errors = new Array<IErrorModel>();
      this.$data.hasConfirmedError = false;

      if (this.$data.RCEnvironment.VUE_APP_ENABLE_RECAPTCHA == true) {
        recaptchaService.getToken(this, "login").then(token => {
          this.$data.form.Token = token;

          setTimeout(() => {
            recaptchaService.verify(this, this.$data.form.Token)
              .then(response => {
                if (!response.Success) {
                  this.$data.isIdentifying = false;
                  this.$data.errors = [{ Property: "", ErrorMessage: "An error occured. Please try again later." } as IErrorModel];
                  this.$store.dispatch("updateIsLoading", false);
                  return;
                }

                if (!response.IsValid) {
                  this.$data.isIdentifying = false;
                  this.$data.errors = [{ Property: "", ErrorMessage: "You are not allowed to log in." } as IErrorModel];
                  this.$store.dispatch("updateIsLoading", false);
                  return;
                }

                this.identifyUserRequest();
              });
          }, 300);
        }).catch(() => {
          this.$data.isIdentifying = false;
        });
      } else {
        this.identifyUserRequest();
      }
    }

    identifyUserRequest() {
      const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "log/identify";

      accountService.post<IIdentifyUserModel, IIdentifyUserResultModel>(this, url, this.$data.form)
        .then(response => {
          this.$store.dispatch("updateIsLoading", false);
          this.$data.isIdentifying = false;

          if (response.AuthType == 2) {
            this.$emit('update:view', 'LoginPartner', response);
            return;
          }

          this.$emit('update:view', 'LoginPassword', response);
        })
        .catch(error => {
          const errors = error.data.ErrorMessages as Array<IErrorModel>;
          this.$data.isIdentifying = false;

          errors.forEach(err => {
            if (err.ErrorMessage == "ERROR_USER_CONFIRMED") {
              this.$data.hasConfirmedError = true;
            }
            else if (err.ErrorMessage == "ERROR_USER_IP_BANNED") {
              err.ErrorMessage = "ERROR_USER_IP_BANNED_LOGIN";
              this.$data.errors.push(err);
            }
            else {
              this.$data.errors.push(err);
            }
          });

          this.$store.dispatch("updateIsLoading", false);
        });
    }

    public updateStringValue(parameterName: string, value: string) {
      this.$data.form[parameterName] = value;
    }
  }
